import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["list"];

  declare urlValue: string;
  declare listTarget: HTMLElement;
  private draggedItem: HTMLElement | null = null;

  connect(): void {
    this.listTarget
      .querySelectorAll<HTMLElement>("[data-section-id]")
      .forEach((item) => {
        item.draggable = true;
        item.addEventListener("dragstart", () => this.onDragStart(item));
        item.addEventListener("dragover", this.onDragOver);
        item.addEventListener("drop", (e) => this.onDrop(item, e));
        item.addEventListener("dragend", () => this.onDragEnd());
      });
  }

  private onDragStart(item: HTMLElement): void {
    this.draggedItem = item;
    item.style.opacity = "0.5";
  }

  private onDragOver = (e: DragEvent): void => {
    e.preventDefault();
  };

  private onDrop(target: HTMLElement, e: DragEvent): void {
    e.preventDefault();
    if (!this.draggedItem || this.draggedItem === target) return;
    const rect = target.getBoundingClientRect();
    const insertAfter = e.clientY - rect.top > rect.height / 2;
    target.parentNode?.insertBefore(
      this.draggedItem,
      insertAfter ? target.nextSibling : target
    );
    this.persistOrder();
  }

  private onDragEnd(): void {
    if (this.draggedItem) this.draggedItem.style.opacity = "";
    this.draggedItem = null;
  }

  private persistOrder(): void {
    const ids = Array.from(
      this.listTarget.querySelectorAll<HTMLElement>("[data-section-id]")
    ).map((el) => el.dataset.sectionId);
    const token = (
      document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null
    )?.content;
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token || "",
        Accept: "application/json",
      },
      body: JSON.stringify({ positions: ids }),
      credentials: "same-origin",
    });
  }
}
